module.exports = __webpack_public_path__ + "img/pdf_bad60.png";